import React from 'react';
import { RankMedal } from 'src/utils/types';
import icMedalTutorial from 'assets/img/ic_md_tutorial.png';
import icMedalRecruit from 'assets/img/ic_md_recruit.png';
import icMedalPrivate from 'assets/img/ic_md_private.png';
import icMedalBronze from 'assets/img/ic_md_bronze.png';
import icMedalSilver from 'assets/img/ic_md_silver.png';
import icMedalGold from 'assets/img/ic_md_gold.png';
import icMedalPlatinum from 'assets/img/ic_md_platinum.png';
import icMedalDiamond from 'assets/img/ic_md_diamond.png';
import icMedalMaster from 'assets/img/ic_md_master.png';
import icMedalChampion from 'assets/img/ic_md_champion.png';
import icMedalSuperChampion from 'assets/img/ic_md_super_champion.png';
const iconMap = {
  [RankMedal.TUTORIAL]: icMedalTutorial,
  [RankMedal.RECRUIT]: icMedalRecruit,
  [RankMedal.PRIVATE]: icMedalPrivate,
  [RankMedal.BRONZE]: icMedalBronze,
  [RankMedal.SILVER]: icMedalSilver,
  [RankMedal.GOLD]: icMedalGold,
  [RankMedal.PLATINUM]: icMedalPlatinum,
  [RankMedal.DIAMOND]: icMedalDiamond,
  [RankMedal.MASTER]: icMedalMaster,
  [RankMedal.CHAMPION]: icMedalChampion,
  [RankMedal.SUPER_CHAMPION]: icMedalSuperChampion
};

const RankMedalIcon = ({
  className,
  value
}) => {
  return /*#__PURE__*/React.createElement("img", {
    className: className,
    src: iconMap[value]
  });
};

export default RankMedalIcon;